// extracted by mini-css-extract-plugin
module.exports = {"photoIcon":"album-badges-photoicon_photoIcon__2qN9-"};